import * as actions from "./actions";

const initialstate = {
  url: process.env.REACT_APP_SPIRIT_URL,
  // url: "http://localhost:4001",
  //  url : "https://www.spiritaircargohandling.com",
  PageTitle: "",
  BannerText: null,
  HomeText: "",
  HomeBannerText: "",
  HomeBgImage: "",
  CphRates: [],
  BillundRates: [],
  ContactCopenhagen: {},
  ContactBillund: {},
  Services: [],
  Faq: [],
  Location: [],
  AboutUsBanner: {},
  AboutUsContent: [],
  Certificates: [],
};

const Authreducer = (state = initialstate, action) => {
  switch (action.type) {
    case actions.Set_Data:
      return {
        ...state,
        home: action.home,
      };

    case actions.SET_RATES:
      return {
        ...state,
        CphRates: action.payload.CphRates,
        BillundRates: action.payload.BillundRates,
      };

    case actions.SET_CONTACT_COPENHAGEN:
      return {
        ...state,
        ContactCopenhagen: action.payload,
      };

    case actions.SET_CONTACT_BILLUND:
      return {
        ...state,
        ContactBillund: action.payload,
      };

    case actions.SET_SERVICES:
      return {
        ...state,
        Services: action.payload,
      };

    case actions.SET_FAQ:
      return {
        ...state,
        Faq: action.payload,
      };

    case actions.SET_LOCATION:
      return {
        ...state,
        Location: action.payload,
      };

    case actions.SET_ABOUT_US_BANNER:
      return {
        ...state,
        AboutUsBanner: action.payload,
      };

    case actions.SET_ABOUT_US_CONTENT:
      return {
        ...state,
        AboutUsContent: action.payload,
      };

    case actions.SET_CERTIFICATES:
      return {
        ...state,
        Certificates: action.payload,
      };

    case actions.SET_HOMEPAGE_DATA:
      return {
        ...state,
        PageTitle: action.payload.PageTitle || "",
        BannerText: action.payload.BannerText || null,
        HomeText: action.payload.HomeText || "",
        HomeBannerText: action.payload.HomeBannerText || "",
        HomeBgImage: action.payload.Image || "",
      };

    default:
      return state;
  }
};

export default Authreducer;
